import { DatePicker, FileUpload, InputField, MLInputField, MLTextArea } from '@/components/Exporter'
import { Icon } from '@iconify/react/dist/iconify.js'
import { useTranslation } from 'react-i18next'

const PersonalInfo = ({ formHandler, handleProfileImageChange, profileImage }) => {
    const { t } = useTranslation()


    return (
        <div className="form-section">
            <div className="section-header">
                <Icon icon="mdi:account-circle" className="section-icon" />
                <h2>{t('personal-contact-information')}</h2>
            </div>

            <div className="section-content">
                <FileUpload label={t('doctors-picture')} accept="image/*" value={profileImage} setValue={handleProfileImageChange} isRequired={false} />

                <div className="row">
                    <MLInputField name="doctorName" formHandler={formHandler} isLoading={false} isRequired />

                    <InputField isRequired={false} lang={"any"} type={"email"} name="email" formHandler={formHandler} isLoading={false} />
                    <InputField isRequired={false} type={"number"} name="phoneNumber" formHandler={formHandler} isLoading={false} />
                    <DatePicker
                        name="birthDate"
                        formHandler={formHandler}
                        minDate={1900}
                        maxDate={new Date().getFullYear() - 26}
                        isSingle
                        placeholder={t('birthDate')}
                        isLoading={false} isRequired />


                    <MLTextArea name="bio" formHandler={formHandler} />

                </div>
            </div>
        </div>

    )
}

export default PersonalInfo